import React, { useState } from 'react';

export default function RiskToleranceStep({ onNext, onBack, data }) {
  const [selectedRisk, setSelectedRisk] = useState(data.riskTolerance || '');

  const riskLevels = [
    {
      id: 'low',
      title: 'Low',
      description: 'Conservative approach with capital preservation focus.',
      color: '#10b981', // Green
    },
    {
      id: 'medium',
      title: 'Medium',
      description: 'Balanced strategy with moderate growth objectives.',
      color: '#f59e0b', // Orange
    },
    {
      id: 'high',
      title: 'High',
      description: 'Aggressive positioning for maximum growth potential.',
      color: '#ef4444', // Red
    }
  ];

  const handleNext = () => {
    if (selectedRisk) {
      onNext({ riskTolerance: selectedRisk });
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-900 via-gray-800 to-gray-900 flex flex-col">
      {/* Background Grid Pattern */}
      <div className="absolute inset-0 opacity-30">
        <div className="absolute inset-0" style={{
          backgroundImage: `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 100 100'%3E%3Cdefs%3E%3Cpattern id='grid' width='10' height='10' patternUnits='userSpaceOnUse'%3E%3Cpath d='M 10 0 L 0 0 0 10' fill='none' stroke='rgba(255,255,255,0.1)' stroke-width='0.5'/%3E%3C/pattern%3E%3C/defs%3E%3Crect width='100' height='100' fill='url(%23grid)'/%3E%3C/svg%3E")`,
        }} />
      </div>

      <div className="flex-1 flex flex-col justify-start items-center px-4 pt-4 relative z-10">
        {/* Logo and Brand */}
        <div className="text-center mb-6 px-2 mt-2">
          <div className="w-12 h-12 bg-gradient-to-br from-blue-500 to-blue-600 rounded-full flex items-center justify-center mx-auto mb-2 shadow-lg">
            <span className="text-white font-bold text-lg">CI</span>
          </div>
          <h1 className="text-white text-lg font-semibold">CryptoIndicators.AI</h1>
        </div>

        {/* Main Question */}
        <div className="text-center mb-6 max-w-md px-2">
          <h2 className="text-2xl font-bold text-white mb-2">
            What's your risk tolerance?
          </h2>
        </div>

        {/* Risk Level Options */}
        <div className="w-full max-w-md space-y-3 mb-6 px-2">
          {riskLevels.map((risk) => (
            <button
              key={risk.id}
              onClick={() => setSelectedRisk(risk.id)}
              className={`w-full p-4 rounded-xl border-2 transition-all duration-300 ${
                selectedRisk === risk.id
                  ? 'bg-gray-800 border-blue-500 shadow-lg shadow-blue-500/20'
                  : 'bg-gray-800/50 border-gray-700 hover:border-gray-600 hover:bg-gray-800/70'
              }`}
            >
              <div className="flex items-center space-x-4">
                {/* Toggle Switch */}
                <div className="flex-shrink-0">
                  <div 
                    className={`w-12 h-6 rounded-full transition-all duration-300 ${
                      selectedRisk === risk.id 
                        ? 'bg-blue-500' 
                        : 'bg-gray-600'
                    }`}
                  >
                    <div 
                      className={`w-5 h-5 rounded-full bg-white shadow-md transition-all duration-300 transform ${
                        selectedRisk === risk.id 
                          ? 'translate-x-6' 
                          : 'translate-x-0.5'
                      }`}
                      style={{
                        marginTop: '2px'
                      }}
                    />
                  </div>
                </div>
                
                {/* Text Content */}
                <div className="flex-1 text-left">
                  <h3 className="font-semibold text-white text-xl mb-1">
                    {risk.title}
                  </h3>
                  <p className="text-gray-400 text-sm">
                    {risk.description}
                  </p>
                </div>
              </div>
            </button>
          ))}
        </div>

        {/* Next Button */}
        <div className="w-full max-w-md px-2">
          <button
            onClick={handleNext}
            disabled={!selectedRisk}
            className="w-full py-4 bg-blue-600 text-white font-semibold rounded-xl hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 focus:ring-offset-gray-900 disabled:opacity-50 disabled:cursor-not-allowed transition-all duration-300 transform hover:scale-[1.02] active:scale-[0.98] shadow-lg"
          >
            Next
          </button>
        </div>
      </div>
    </div>
  );
} 